import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import { useRecoilState } from "recoil";
import Modal from "modal-react-native-web";
import { styles, stylesResponsive } from "./style";
import { tokenState } from "../../reducer/recoil";
import { getstatus } from "../../action/authAction";
import moment from "moment";
import { useIsFocused } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
export default function index({ navigation, error, route }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);
  const [details, setDetails] = useState(null);
  const [data, setData] = useState([]);
  const [country, setCountry] = useState([]);
  const [event, setEvent] = useState([]);
  const [fil, setFil] = useState("");
  const [prelimChange, setprelimChange] = useState(null);
  const [finalChange, setfinalChange] = useState(null);

  console.log("prelimChange", prelimChange);
  console.log("finalChange", finalChange);

  // country
  const [req_data, req_setData] = useState([]);
  const isFocus = useIsFocused();

  function onModalShow() {
    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  React.useEffect(() => {
    apiGet({ state: 1 });
  }, [isFocus, token]);

  async function apiGet({ state }) {
    const response = await getstatus({
      state: route.params.competition_id,
      token: token.token,
    });

    if (response) {
      setDetails(response.competition);
      req_setData(response.registration);
      setTimeout(() => {
        setData(response.countries.filter((item) => item != null));

        console.log(response.countries);
        setCountry(
          response.countries.map((item) => {
            return { label: item?.country_name, value: item?.country_name };
          })
        );
      }, 300);
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View
            style={[
              width < 1280
                ? stylesResponsive.ModalSendMail
                : styles.ModalSendMail,
              {
                backgroundColor: error ? "#FFDEDE" : "#A7FFB2",
                borderColor: error ? "#B12B2B" : "#36FF5E",
              },
            ]}
          >
            <Text
              style={[
                width < 1280
                  ? stylesResponsive.textModalSendMail
                  : styles.textModalSendMail,
                {
                  color: error ? "#B23131" : "#2BB165",
                },
              ]}
            >
              {error
                ? "E-MAIL NOT SEND. PLEASE TRY AGAIN"
                : "E-MAIL SEND SUCCESS"}
            </Text>
          </View>
        </View>
      </Modal>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITION/${route.params.name}/COUNTRIES STATUS`}
            admin
          />
          {country.length > 0 && (
            <TabbarOption
              country={country}
              onfilter={(val) => {
                if (val != "Countries") {
                  setFil(val);
                } else {
                  setFil("");
                }
              }}
              prelimChange={(e) => {
                setprelimChange(e);
              }}
              finalChange={(e) => {
                setfinalChange(e);
              }}
              competition_id={route.params.competition_id}
              CompeCountriesStatus
              buttonTabbar
            />
          )}
          {width >= 1280 && (
            <View style={[styles.viewTopic]}>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  {
                    width: "25%",
                    paddingRight: width * 0.07,
                  },
                ]}
              >
                {"COUNTRY"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"HOST"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "15%" },
                ]}
              >
                {"REGISTER DATE"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "22%" },
                ]}
              >
                {"PRELIMINARY ENTRY SUBMIT"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "18%" },
                ]}
              >
                {"FINAL ENTRY SUBMIT"}
              </Text>
              <Text numberOfLines={1} style={[styles.textTitle]}></Text>
            </View>
          )}
          <FlatList
            data={data.filter((item) => {
              try {
                return item.country_name
                  .toLowerCase()
                  .includes(fil.toLowerCase());
              } catch (error) {
                return false;
              }
            })}
            extraData={[prelimChange, finalChange]}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              let MeNow = {};
              if (
                req_data.filter(
                  (i) =>
                    item.country_name ==
                    i.Approbation_request_by.Country.country_name
                ).length > 0
              ) {
                MeNow = req_data.filter(
                  (i) =>
                    item.country_name ==
                    i.Approbation_request_by.Country.country_name
                )[0];
              }
              let condition = true;
              if (prelimChange == "ACTIVE") {
                condition = condition && MeNow.created_at != undefined;
              }
              if (prelimChange == "INACTIVE") {
                condition = MeNow.created_at == undefined && condition;
              }
              if (finalChange == "ACTIVE") {
                condition = MeNow.approbation_type == "Final" && condition;
              }
              if (finalChange == "INACTIVE") {
                condition = MeNow.approbation_type !== "Final" && condition;
              }

              if (prelimChange == null && finalChange == null) {
                condition = true;
              }

              return width >= 1280 ? (
                condition && (
                  <View
                    style={[
                      styles.viewDetail,
                      {
                        backgroundColor:
                          index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                        borderTopWidth: index >= 1 ? 0 : 1,
                      },
                    ]}
                  >
                    <View style={styles.sizeImg}>
                      <Image
                        resizeMode={"contain"}
                        style={styles.imgDetail}
                        source={{ uri: item.image_url }}
                      />
                      <Text
                        numberOfLines={1}
                        style={[
                          width < 1600
                            ? styles.textDetailRespons
                            : styles.textDetail,
                          styles.sizeCountry,
                        ]}
                      >
                        {item.country_name}
                      </Text>
                    </View>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                      ]}
                    >
                      {item.country_name ==
                      details.Association.Country.country_name
                        ? "HOST"
                        : "NO HOST"}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "15%" },
                      ]}
                    >
                      {MeNow.created_at != undefined &&
                        moment(MeNow.created_at).format("DD/MM/YYYY")}{" "}
                      {MeNow.created_at != undefined &&
                        moment(MeNow.created_at).format("HH:mm")}
                    </Text>
                    <View style={{ alignItems: "center", width: "22%" }}>
                      <Text
                        numberOfLines={1}
                        style={[
                          width < 1600
                            ? styles.textDetailRespons
                            : styles.textDetail,
                          { width: "100%" },
                        ]}
                      >
                        {MeNow.created_at != undefined &&
                          moment(MeNow.prelim_submit_date)
                            // .utcOffset("+0000")
                            .format("DD/MM/YYYY")}{" "}
                        {MeNow.created_at != undefined &&
                          moment(MeNow.prelim_submit_date)
                            // .utcOffset("+0000")
                            .format("HH:mm")}
                      </Text>
                      {MeNow.created_at != undefined && (
                        <TouchableOpacity
                          onPress={() => {
                            navigation.navigate("PrelimSub", {
                              ...MeNow,
                              ...details,
                              ...item,
                            });
                          }}
                          style={styles.buttonInfo}
                        >
                          <Text
                            style={
                              width < 1600
                                ? styles.textInfoRespons
                                : styles.textInfo
                            }
                          >
                            info
                          </Text>
                        </TouchableOpacity>
                      )}
                    </View>

                    <View style={{ alignItems: "center", width: "18%" }}>
                      {MeNow.approbation_type == "Final" && (
                        <>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {MeNow.updated_at != undefined &&
                              moment(MeNow.final_submit_date).format(
                                "DD/MM/YYYY"
                              )}{" "}
                            {MeNow.updated_at != undefined &&
                              moment(MeNow.final_submit_date).format("HH:mm")}
                          </Text>
                          {MeNow.updated_at != undefined && (
                            <TouchableOpacity
                              onPress={() => {
                                navigation.navigate("FinalSub", {
                                  ...MeNow,
                                  name: route.params.name,
                                });
                              }}
                              style={styles.buttonInfo}
                            >
                              <Text
                                style={
                                  width < 1600
                                    ? styles.textInfoRespons
                                    : styles.textInfo
                                }
                              >
                                info
                              </Text>
                            </TouchableOpacity>
                          )}
                        </>
                      )}
                    </View>

                    <View style={{ width: "10%", alignItems: "center" }}>
                      <TouchableOpacity
                        onPress={onModalShow}
                        style={styles.buttonSendMail}
                      >
                        <Text
                          style={
                            width < 1600
                              ? styles.textInfoRespons
                              : styles.textSendMail
                          }
                        >
                          SEND MAIL
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                )
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <View style={{ width: "60%" }}>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail, { fontSize: 14 }]}
                    >
                      {item.country_name}
                    </Text>

                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail, { fontSize: 14 }]}
                    >
                      {item.country_name ==
                      details.Association.Country.country_name
                        ? "HOST"
                        : "NO HOST"}
                    </Text>
                    {req_data.filter(
                      (i) =>
                        item.country_name ==
                        i.Approbation_request_by.Country.country_name
                    ).length > 0 && (
                      <View>
                        <Text
                          numberOfLines={1}
                          style={[stylesResponsive.textTitle]}
                        >
                          {"REGISTER DATE"}
                        </Text>
                        <Text
                          numberOfLines={1}
                          style={[stylesResponsive.textDetail]}
                        >
                          {MeNow.created_at != undefined &&
                            moment(MeNow.created_at).format("DD/MM/YYYY")}{" "}
                          {MeNow.created_at != undefined &&
                            moment(MeNow.created_at).format("HH:mm")}
                        </Text>
                        <Text
                          numberOfLines={1}
                          style={[stylesResponsive.textTitle]}
                        >
                          {"PRELIMINARY ENTRY SUBMIT"}
                        </Text>
                        <Text
                          numberOfLines={1}
                          style={[stylesResponsive.textDetail]}
                        >
                          {MeNow.created_at != undefined &&
                            moment(MeNow.prelim_submit_date).format(
                              "DD/MM/YYYY"
                            )}{" "}
                          {MeNow.created_at != undefined &&
                            moment(MeNow.prelim_submit_date).format("HH:mm")}
                        </Text>

                        {MeNow.created_at != undefined && (
                          <TouchableOpacity
                            onPress={() => {
                              navigation.navigate("PrelimSub", {
                                ...MeNow,
                                ...details,
                                ...item,
                              });
                            }}
                            style={stylesResponsive.buttonInfo}
                          >
                            <Text style={stylesResponsive.textInfo}>info</Text>
                          </TouchableOpacity>
                        )}

                        {MeNow.approbation_type == "Final" && (
                          <Text
                            numberOfLines={1}
                            style={[stylesResponsive.textTitle]}
                          >
                            {"FINAL ENTRY SUBMIT"}
                          </Text>
                        )}
                        {MeNow.approbation_type == "Final" && (
                          <Text
                            numberOfLines={1}
                            style={[stylesResponsive.textDetail]}
                          >
                            {MeNow.updated_at != undefined &&
                              moment(MeNow.final_submit_date).format(
                                "DD/MM/YYYY"
                              )}{" "}
                            {MeNow.updated_at != undefined &&
                              moment(MeNow.final_submit_date).format("HH:mm")}
                          </Text>
                        )}

                        {MeNow.approbation_type == "Final" &&
                          MeNow.created_at != undefined && (
                            <TouchableOpacity
                              onPress={() => {
                                navigation.navigate("FinalSub", {
                                  ...MeNow,
                                  name: route.params.name,
                                });
                              }}
                              style={stylesResponsive.buttonInfo}
                            >
                              <Text style={stylesResponsive.textInfo}>
                                info
                              </Text>
                            </TouchableOpacity>
                          )}
                      </View>
                    )}

                    <TouchableOpacity
                      onPress={onModalShow}
                      style={stylesResponsive.buttonSendMail}
                    >
                      <Text style={stylesResponsive.textSendMail}>
                        SEND MAIL
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
